export enum TaskOutcome {
  success = 0,
  failure = 1,
  repeat = 2,
  inProgress = 3,
  escalated = 4
}
